export enum CheckoutPaymentType {
  None = 0,
  Credit = 1,
  MeshutafPayment = 2,
  CheckOrCash = 3,
  FreeCheckout = 4,
}



// WEBPACK FOOTER //
// ./src/app/_models/checkout-payment-type.ts